<template>
    <div>
        <h3>Resize</h3>
        <p>Resizing will change the storage size, CPU and RAM of your Cloud Server.</p>

        <p class="sau-font-bold mb-0">Current Plan: {{ hosting.product.name }}</p>
        <p>{{ hosting.product.config.cpu_cores }} Cores / {{ hosting.product.config.memory }} / {{ hosting.product.config.disk_space }} / {{hosting.product.config.bandwidth }}</p>

        <template v-if="hosting.upgrades.length == 0">
            <b-alert show variant="info">There are no resize tiers available for your service.
                <p class="mb-0">Contact <a href="mailto:sales@serversaustralia.com.au">sales@serversaustralia.com.au</a> if you'd like to discuss other options.</p></b-alert>
        </template>
        <template v-else>
            <b-alert show variant="info">Plans with storage smaller than your current storage ({{ hosting.product.config.disk_space }}) are not shown, as it's not possible to downgrade storage size.</b-alert>
            <sau-dynamic-table :data="hosting.upgrades" :config="tableConfig">
                <template #table-header>
                    <tr>
                        <th>Name</th>
                        <th>CPU Cores</th>
                        <th>Memory</th>
                        <th>Storage</th>
                        <th>Transfer</th>
                        <th>$/Month</th>
                        <th></th>
                    </tr>
                </template>

                <template v-slot="{ item }">
                    <tr :class="{ 'bg-blue-100' : selectedProduct == item }" @click="selectedProduct = item">
                        <td>{{ item.name }}</td>
                        <td>{{ item.config.cpu_cores }}</td>
                        <td>{{ item.config.memory }}</td>
                        <td>{{ item.config.disk_space }}</td>
                        <td>{{ item.config.bandwidth }}</td>
                        <td>{{ item.monthly_price | currency}}</td>
                        <td class="text-center">
                            <input type="radio" v-model="selectedProduct" :value="item">
                        </td>
                    </tr>
                </template>
            </sau-dynamic-table>
            <p>Your server must reboot to complete the resize process, which can take several minutes. After resizing is completed, your server will automatically be started again. <!--<a href="learn more">Learn More</a>--></p>
            <b-alert show variant="danger">Increasing the storage size is a permanent change and cannot be reversed.</b-alert>
            <div class="text-right">
                <button :disabled="disabled" @click="resize" class="btn btn-success font-bold btn-sm text-uppercase">Reboot and Resize Now</button>
            </div>

        </template>

        <b-modal
            centered title="Resize Initialized"
            @ok="successModalClose()"
            ok-title="Ok"
            ok-variant="success"
            :visible="showSuccessModal"
            :ok-only="true"
            :no-close-on-backdrop="true"
            :no-close-on-esc="true">
            <p>Your resize has begun. Please allow a few minutes for this process to complete. During this time your Cloud Server will be restarted.</p>
        </b-modal>
        <b-modal
            centered title="Something went wrong"
            @ok="showFailedModal = false"
            ok-title="Ok"
            ok-variant="success"
            :visible="showFailedModal"
            :no-close-on-backdrop="true"
            @cancel="contactSupport()"
            cancel-variant="text"
            cancel-title="Contact Support"
            :no-close-on-esc="true">
            <p>Failed to resize your server. Please try again later, or contact support.</p>
        </b-modal>
    </div>
</template>

<script>

import axios from 'axios';
import SauDynamicTable from '@v1/utilities/SauTable';

export default {

    props: ['service', 'hosting'],

    components: { SauDynamicTable },

    data() {
        return {
            selectedProduct: null,
            resizing: false,
            tableConfig: {
                paginator: {
                    enabled: false,
                    itemsPerPage: 25,
                    page: 1,
                },
            },
            showSuccessModal: false,
            showFailedModal: false,
            resizeHasBeenTriggered: false,
        }
    },

    methods: {
        resize() {
            this.resizing = true;
            axios.post(`/api/v2/services/${this.hosting.id}/resize`, { resize_product_id: this.selectedProduct.id })
                .then(() => {
                    this.showSuccessModal = true;
                    this.resizeHasBeenTriggered = true; // Disable any more resize attempts
                }).catch(() => {
                    this.showFailedModal = true;
                }).finally(() => {
                    this.resizing = false;
                });
        },
        contactSupport() {
            window.location.href = '/support/cases/create';
        },
        successModalClose() {
            this.showSuccessModal = false;
            window.location.href = 'summary';
        }
    },

    computed: {
        disabled() {
            return !this.selectedProduct || this.resizing || this.resizeHasBeenTriggered;
        }
    }
}
</script>
